import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Colgroup from './colgroup';
import Tbody from './tbody';

import styles from './expanding-table.module.less';

const ExpandingTable = ({ columns, data }) => (
  <div className={styles.tableContainer}>
    <table className={styles.table}>
      <Colgroup columns={columns} />
      <thead className={styles.thead}>
        <tr>
          {columns.map((column) => (
            <th
              key={column.id}
              className={classNames([column.id, styles.th])}
              style={{ width: column.width }}
              scope="col"
            >
              {column.heading}
            </th>
          ))}
        </tr>
      </thead>
      {data.map((row, index) => (
        <Tbody columns={columns} row={row} index={index} />
      ))}
    </table>
  </div>
);

/**
 * Data structure borrowed from @nerdwallet/react-table, as we want to be able to store table configuration
 * the same way
 */
ExpandingTable.propTypes = {
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      /**  Unique ID to be referenced as a prop in row data. */
      id: PropTypes.string.isRequired,
      /** Heading to appear in the column's <th>. */
      heading: PropTypes.node,
      /** Explicit width for the column. */
      width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    })
  ).isRequired,
  data: PropTypes.object.isRequired,
};

export default ExpandingTable;
